import React from 'react';
import ClassAssembly  from 'views/ClassAssembly7E';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;